import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

import { CNMCFile } from '../types';

export type TInitMultipartUploadParams = {
  cnmcId: string;
  filename: string;
  mimetype: string;
};

export async function initMultipartUpload({
  cnmcId,
  filename,
  mimetype,
}: TInitMultipartUploadParams): Promise<CNMCFile> {
  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/files/init`, {
    filename,
    mimetype,
  });
}

type MutationFn = typeof initMultipartUpload;

type TUseInitMultipartUploadParams = {
  config?: MutationConfig<MutationFn>;
};

export function useInitMultipartUpload({ config = {} }: TUseInitMultipartUploadParams = {}) {
  return useMutation({
    ...config,
    mutationFn: initMultipartUpload,
    onError(error) {
      console.error(error);
    },
  });
}
